import React from 'react';
import PropTypes from 'prop-types';
import TabsModule from 'react-responsive-tabs';

import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import './index.scss';

import 'react-responsive-tabs/styles.css';

/**
 * @todo Jake Harris
 * This can be removed once we upgrade `react-responsive-tabs` to
 * a version that supports ES modules. That said, that package does
 * not seem maintained, so it may take a replacement instead.
 * (as of 5/31/24)
 */
const Tabs = TabsModule.default; // take advantage of `esModuleInterop` for this CommonJS module

export default class TabMenu extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    tabLinks: PropTypes.array,
  };

  static defaultProps = {
    onChange: null,
    tabLinks: [],
  };

  getTabs() {
    return this.props.tabLinks.map((datum) => {
      return {
        title: (
          <a
            className={'tabWrapper'}
            href={datum.url}
            onClick={(event) => event.preventDefault()}>
            {datum.notify ? <div className={'notify'} /> : null}
            <div>{datum.label}</div>
            {datum.locked ? (
              <SvgSymbol className={'svg-symbol-tab-lock'} name={'lock'} />
            ) : null}
          </a>
        ),
        getContent: () => datum.url,
        key: datum.url,
        tabClassName: 'reactive-tab',
        panelClassName: 'reactive-panel',
      };
    });
  }

  getActiveTab() {
    return this.props.tabLinks
      .filter((datum) => datum.active === true)
      .map((datum) => datum.url)[0];
  }

  render() {
    return (
      <div className='basic__tabs'>
        <Tabs
          items={this.getTabs()}
          onChange={this.props.onChange}
          selectedTabKey={this.getActiveTab()}
          showInkBar={true}
          showMore={true}
          showMoreLabel={t('More')}
          transform={false}
        />
      </div>
    );
  }
}
